// При infinite: true и количестве товаров меньше slidesToShow react-slick
// подклеивает товары-клоны, чтобы заполнить ряд — это даёт пустые/повторяющиеся
// карточки на визуально "рваных" каруселях. Решение — считать slidesToShow
// по фактическому количеству товаров и выключать infinite/autoplay, когда
// крутить нечего (товаров не больше, чем показываем за раз).
export const getSliderSettings = (itemsCount, { autoplaySpeed = 4000 } = {}) => {
  const maxSlides = 5;
  const slidesToShow = Math.max(1, Math.min(maxSlides, itemsCount || 1));
  const canLoop = (itemsCount || 0) > slidesToShow;

  return {
    dots: false,
    infinite: canLoop,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: canLoop,
    autoplaySpeed,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: Math.min(3, slidesToShow) },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: Math.min(2, slidesToShow) },
      },
    ],
  };
};
